import { createRouter, createWebHistory } from 'vue-router'

import Activation1 from '../views/Activation1.vue'
import Activation2 from '../views/Activation2.vue'
import Activation3 from '../views/Activation3.vue'

import Login from '../views/Login.vue'
import Recovery from '../views/Recovery.vue'
import Reset from '../views/Reset.vue'

import Dashboard from '../views/Dashboard.vue'
import Profile from '../views/Profile.vue'
import Email from '../views/Email.vue'
import Mobile from '../views/Mobile.vue'

import AdminLogin from '../views/admin/AdminLogin.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import AdminRecovery from '../views/admin/AdminRecovery.vue'
import AdminReset from '../views/admin/AdminReset.vue'

import NotFound from '../views/NotFound.vue'

import store from '../store'

const routes = [
    {
        path: '/activation',
        name: 'Activation1',
        component: Activation1,
    },
    {
        path: '/activation/:token',
        name: 'Activation2',
        component: Activation2,
    },
    {
        path: '/a/:token',
        name: 'Activation3',
        component: Activation3,
    },
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: {
            auth: false,
        },
    },
    {
        path: '/mot-de-passe',
        name: 'Recovery',
        component: Recovery,
        meta: {
            auth: false,
        },
    },
    {
        path: '/r/:token',
        name: 'Reset',
        component: Reset,
    },
    {
        path: '/suivi',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            auth: true,
            admin: false,
        },
    },
    {
        path: '/profil',
        name: 'Profile',
        component: Profile,
        meta: {
            auth: true,
            admin: false,
        },
    },
    {
        path: '/e/:token',
        name: 'Email',
        component: Email,
    },
    {
        path: '/m/:token',
        name: 'mobile',
        component: Mobile,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },
    {
        path: '/admin',
        name: 'AdminLogin',
        component: AdminLogin,
        meta: {
            auth: false,
        },
    },
    {
        path: '/admin/mot-de-passe',
        name: 'AdminRecovery',
        component: AdminRecovery,
        meta: {
            auth: false,
        },
    },
    {
        path: '/r/admin/:token',
        name: 'AdminReset',
        component: AdminReset,
    },
    {
        path: '/admin/dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: {
            auth: true,
            admin: true,
        },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

// Handle redirections
router.beforeEach((to, from, next) => {
    store.dispatch('initAuth').then(() => {
        const isAuth = store.getters['isAuth']
        const isAdmin = store.getters['isAdmin']
        if (to.matched.some((route) => route.meta.auth) && !isAuth) {
            ///console.log('REDIRECT TO LOGIN')
            next({ name: 'Login' })
        } else if (to.matched.some((route) => route.meta.auth === false) && isAuth) {
            if (isAdmin) {
                next({ name: 'AdminDashboard' })
            } else {
                next({ name: 'Dashboard' })
            }
        } else {
            if (to.matched.some((route) => route.meta.admin === true) && isAuth && !isAdmin) next({ name: 'Dashboard' })
            if (to.matched.some((route) => route.meta.admin === false) && isAuth && isAdmin) next({ name: 'AdminDashboard' })
            next()
        }
    })
})

export default router
